import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  surface?: '0' | '1' | '2' | '3' | '4'
  withBorder?: boolean
}

export const Section = forwardRef<HTMLElement, SectionProps>(
  ({ className, surface = '0', withBorder = false, children, ...props }, ref) => {
    const surfaceClasses = {
      '0': 'bg-surface-0',
      '1': 'bg-surface-1',
      '2': 'bg-surface-2',
      '3': 'bg-surface-3',
      '4': 'bg-surface-4',
    }

    return (
      <section
        ref={ref}
        className={cn(
          'py-12 sm:py-16 md:py-24 transition-colors duration-200',
          surfaceClasses[surface],
          withBorder && 'border-y border-border-subtle',
          className
        )}
        {...props}
      >
        {children}
      </section>
    )
  }
)

Section.displayName = 'Section'
